import { useWSMutation, WSMutationsConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_BENEFITS_PLAN_ENROLLMENT } from "./useQueryPlanEnrollment";
import { QUERY_BENEFITS_PLAN_ENROLLMENTS } from "./useQueryPlanEnrollments";
import { createPlanEnrollment } from "../../services/api/planEnrollment/createPlanEnrollment";
import { REQUIREMENTS_DEPENDENCIES } from "../../modules/Requirements/dependencies";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;
type IPlanEnrollmentCreateRequest =
  planEnrollmentApiSpec.operations["enrollPlan"]["requestBody"]["content"]["application/json"];

export const useMutationCreatePlanEnrollment = (
  config?: WSMutationsConfig<
    IPlanEnrollment,
    WSServiceError,
    IPlanEnrollmentCreateRequest
  >
) =>
  useWSMutation(
    (request: IPlanEnrollmentCreateRequest) => createPlanEnrollment(request),
    {
      dependencies: [
        QUERY_BENEFITS_PLAN_ENROLLMENT,
        QUERY_BENEFITS_PLAN_ENROLLMENTS,
        ...REQUIREMENTS_DEPENDENCIES
      ],
      ...config
    }
  );
